import { PkDivider } from '@uefadigital/panenka-react';

import { useStatisticOptions } from '../../store';
import Categories from '../Categories';
import Filters from '../Filters';
import Table from '../Table';

import { useWindowSize } from '@hooks/useWindowSize';

import * as styles from './styles.module.scss';

export const Main = () => {
  const { isMobile, isDesktopExtraLarge } = useWindowSize();
  const {
    options: { disablePhaseFilter, statType },
  } = useStatisticOptions();

  const showFilters = !(disablePhaseFilter && statType === 'team');

  return (
    <div className='pk-container'>
      <div className='pk-col pk-col--span-12'>
        {!isMobile && (
          <div className={styles.filtersWrap}>
            <Categories />
            {showFilters && !isDesktopExtraLarge ? <Filters /> : <div />}
          </div>
        )}
        {isMobile && <Categories />}
        <PkDivider />
        {isMobile && (
          <div className={`${styles.filtersWrap} ${styles.filtersWrapMobile}`}>{showFilters && <Filters />}</div>
        )}
        <div className={styles.filtersWrap}>
          {showFilters && isDesktopExtraLarge && <Filters />}
          <Table />
        </div>
      </div>
    </div>
  );
};

export default Main;
